import { render, staticRenderFns } from "./addChapter.vue?vue&type=template&id=71bb8da3"
import script from "./addChapter.vue?vue&type=script&lang=js"
export * from "./addChapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports